import React, { ReactNode } from 'react';
import { cn } from '../../../lib/utils'; // Assuming Shadcn utility helper or I'll create one

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
    size?: 'sm' | 'md' | 'lg';
    children: ReactNode;
}

export const Button = ({
    children,
    onClick,
    variant = 'primary',
    size = 'md',
    className = '',
    disabled = false,
    ...props
}: ButtonProps) => {
    const variants = {
        primary: 'bg-violet-600 border border-transparent text-white shadow-lg shadow-violet-500/25 hover:bg-violet-700 hover:shadow-violet-500/40',
        secondary: 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 shadow-sm',
        ghost: 'bg-transparent text-slate-600 hover:bg-slate-100/50 hover:text-slate-900',
        danger: 'bg-red-50 text-red-600 border border-red-100 hover:bg-red-100',
    };

    const sizes = {
        sm: 'px-3 py-1.5 text-xs',
        md: 'px-5 py-2.5 text-sm',
        lg: 'px-6 py-3 text-base',
    };

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
        relative overflow-hidden font-medium rounded-xl transition-all duration-300 active:scale-95 flex items-center justify-center gap-2
        ${variants[variant]}
        ${sizes[size]}
        ${disabled ? 'opacity-50 cursor-not-allowed grayscale' : ''}
        ${className}
      `}
            {...props}
        >
            {children}
        </button>
    );
};
